:host {
    position: fixed;
    top: calc(var(--header-height) + 32px);
    right: 0;

    > div {
        @include grid;
    }

    sew-ws-notification {
        grid-column: 10 / -1;
    }

    sew-ws-notification:not(:first-of-type) {
        margin-top: 16px;
    }
}

@include mq-2 {
    :host {
        top: calc(var(--header-height) + 24px);

        sew-ws-notification {
            grid-column: 8 / -1;
        }
    }
}

@include mq-1 {
    :host {
        sew-ws-notification {
            grid-column: 2 / -1;
        }
    }
}
